import React from "react";
import { Link } from "react-router-dom";
import "./TeacherSidebar.css";
import HelpLink from "../HelpLink";

interface TeacherSidebarProps {
  children: React.ReactChildren | React.ReactChild;
  header: React.ReactChildren | React.ReactChild;
}

const TeacherSidebar = (props: TeacherSidebarProps) => (
  <div className="TeacherSidebar">
    {props.header}
    <div className="links">
      <div className="scrollable">{props.children}</div>
      <div className="helpLinks">
        <Link to="/Settings">Settings</Link>
        <HelpLink type="default">Help Center</HelpLink>
        <HelpLink type="contact">Contact Support</HelpLink>
      </div>
    </div>
  </div>
);

export default TeacherSidebar;
